<header class="header">
  <div class="container">
    <div class="brand-bar">
      <a *ngIf="!disableToggle" class="btn-toggle" [class.close]="isOpened" (click)="toggle()">
        <fa-icon *ngIf="!isOpened" [icon]="icons.menu"></fa-icon>
        <fa-icon *ngIf="isOpened" [icon]="icons.close"></fa-icon>
      </a>
      <app-logo class="logo" secondary></app-logo>
    </div>
    <div class="action">
      <app-button dataTest="logout-btn" accent (click)="logout()">
        Logout
      </app-button>
    </div>
  </div>
</header>